import { render, staticRenderFns } from "./nav-left.vue?vue&type=template&id=8296376a&scoped=true&"
import script from "./nav-left.vue?vue&type=script&lang=ts&"
export * from "./nav-left.vue?vue&type=script&lang=ts&"
import style0 from "./nav-left.vue?vue&type=style&index=0&id=8296376a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8296376a",
  null
  
)

export default component.exports